// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".last-run-row--timestamp--1SwbY6Vh {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  font-size: 13px;\n  height: calc(44px - 10px);\n  justify-content: center;\n  padding: 5px 10px;\n  width: 62px;\n}\n.last-run-row--timestamp--1SwbY6Vh.last-run-row--borders--DliXgLSA {\n  border-right: solid 3px white;\n  border-bottom: solid 1px #dfdfdf;\n  border-left: solid 3px white;\n  height: calc(100% - 42px);\n  justify-content: flex-start;\n  margin: -1px 0 0 -3px;\n  padding: 21px 10px;\n  width: 62px;\n}\n.last-run-row--timestamp--1SwbY6Vh.last-run-row--compact--2BIA5smp {\n  height: 22px;\n}\n.last-run-row--timestamp--1SwbY6Vh div.last-run-row--visuallyHidden--2QUBVnxN {\n  display: none;\n}\n", ""]);
// Exports
exports.locals = {
	"timestamp": "last-run-row--timestamp--1SwbY6Vh",
	"borders": "last-run-row--borders--DliXgLSA",
	"compact": "last-run-row--compact--2BIA5smp",
	"visuallyHidden": "last-run-row--visuallyHidden--2QUBVnxN"
};
module.exports = exports;
